import { NoContentBlock } from "../ui";
import { Stack } from "@mui/material";

export const NoAccountData = () => {
  return (
    <Stack gap="8px" alignItems="center" justifyContent="center" padding="32px">
      <NoContentBlock
        title={"No Matching Accounts"}
        text={
          "No accounts match the current filters. Try changing or clearing them to " +
          "see more results."
        }
      />
    </Stack>
  );
};
